import React from 'react';
import { render } from 'react-dom';
import App from './app';
import {
    initDimensionsFromState,
    trackInitialPageView,
} from '@eb/site-analytics';

// retrieve data from server to hydrate the client
const props = window.__SERVER_DATA__ || {};

// render app with server props to the DOM
render(<App {...props} />, document.getElementById('root'));

// set up initial GA tracking
const { launchNewNavigationHeader } = props.env;
const dimensions = launchNewNavigationHeader && {
    experimentId3: '20q4navexperiment',
};

initDimensionsFromState(props);
trackInitialPageView(props.gaSettings, { dimensions });
